import { Flex, Heading, useBoolean, Button, useToast} from '@chakra-ui/react'

import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ConceptsList } from '../../containers/concepts'
import { PageToolbar } from '../../containers/PageToolbar'
import { conceptsProperties } from '../../data/concepts'
import { SearchButton } from '../../containers/search/SearchButton'
import { PageContent } from '../../containers/PageContent'
import { useEffect, useState } from 'react'
import { ConceptsPropertySearchForm } from '../../containers/search/chaloupka/ConceptsPropertySearchForm'
import { IPageLimit, IParams } from '../../model/interfaces/entities/IContracts'
import { useSearchParams } from 'react-router-dom'
import { CONCEPTS_LIST_PAGE_LIMIT } from '../chaloupka/constats'
import { convertParamsToSearchParams } from '../../model/utils/urlUtils'
import { omit } from 'lodash'
import { Select, Trash } from '../../icons'
import { useUpdateDiscount } from '../../model/api/offers/useUpdateDiscount'
import { useDeleteOffers } from '../../model/api/offers/useDeleteOffers'

export const ConceptsPropertyPage = () => {
  const [isOpen, setOpen] = useBoolean(false)
  const [isDeleting, setIsDeleting] = useState(false);
  const [itemsToDelete, setItemsToDelete] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useToast()
  const { mutate: deleteOffers, isLoading: isDeletingLoading } = useDeleteOffers(
    () => {
      setItemsToDelete([]);
      setIsDeleting(false);
    },
    (error) => {
      toast({
        title: 'Nepodařilo se smazat',
        description: error?.response?.data?.error,
        status: 'error',
        isClosable: true,
        position: 'top',
        duration: 5000,
      })
    }
  );
  const [params, setRawParams] = useState<IParams & IPageLimit>({
    number: searchParams.get('number') || undefined,
    dateCreatedFrom: searchParams.get('dateCreatedFrom') || undefined,
    dateCreatedTo: searchParams.get('dateCreatedTo') || undefined,
    companyId: searchParams.get('companyId') || undefined,
    client: searchParams.get('client') || undefined,
    in: searchParams.get('in') || undefined,
    organizationId: searchParams.get('organizationId') || undefined,
    userId: searchParams.get('userId') || undefined,
    status: searchParams.get('status') ? searchParams.get('status')!.split(',') : [],
    page: searchParams.get('page') ? parseInt(searchParams.get('page')!) : 1,
    limit: CONCEPTS_LIST_PAGE_LIMIT,
  })

  const setParams = (newParams: IParams & IPageLimit) => {
    setSearchParams(convertParamsToSearchParams(omit(newParams, ['limit'])))
    setRawParams(newParams)
  }

  useEffect(() => {
    if (!isDeleting) {
      setItemsToDelete([]);
    }
  }, [isDeleting])

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Rozpracované nabídky</Heading>
              </Flex>
            }
            rightElements={
              <Flex sx={{ gap: 4 }}>
                <Button variant="unstyled" onClick={() => setIsDeleting(!isDeleting)}>
                  <Select color="secondary.500" sx={{ marginRight: '5px' }} />
                  {isDeleting ? 'Zrušit smazání' : 'Vybrat ke smazání'}
                </Button>
                <SearchButton isOpen={isOpen} setOpen={setOpen} />
              </Flex>
            }
          />

          {isOpen && <ConceptsPropertySearchForm setParams={setParams} params={params} />}

          <ConceptsList
            concepts={conceptsProperties}
            withPaginator
            params={params}
            isDeleting={isDeleting}
            setParams={setParams}
            itemsToDelete={itemsToDelete}
            setItemsToDelete={setItemsToDelete}
          />
          <Flex sx={{ gap: 4 }}>
            {isDeleting && (
              <Button
                variant="outline"
                disabled={itemsToDelete.length === 0 || isDeletingLoading}
                isLoading={isDeletingLoading}
                colorScheme="red"
                onClick={() => {
                  deleteOffers(itemsToDelete);
                }}
                >
                <Trash color="red.500" />
                Smazat {itemsToDelete.length > 0 && (`(${itemsToDelete.length})`)}
              </Button>
            )}
          </Flex>
        </PageContent>
      </Container>
    </Section>
  )
}
